
import { Injectable } from '@angular/core';
import { DistriApiService } from '../distri/distri.api.service';
import { CreerVenteDirectOp } from '../../model/index';

/**
 * Vente: calls distri API (common/vente). Backend calls kaabu-vente-service and returns response normally.
 */
@Injectable()
export class VenteApiService {

    private readonly apiPath = 'common/vente';

    constructor(private apiService: DistriApiService) {}

    venteDirect(obj: CreerVenteDirectOp) {
        return this.apiService.post(this.apiPath + '/vente-directe', obj);
    }

    printFactureDistri(numeroFacture: string, nomVendeur: string, codeVendeur: string, numeroVendeurDistri?: string) {
        const params = new URLSearchParams({
            facture: numeroFacture,
            nom: nomVendeur || '',
            login: codeVendeur || ''
        });
        if (numeroVendeurDistri != null && numeroVendeurDistri !== '') {
            params.set('numeroVendeurDistri', numeroVendeurDistri);
        }
        const endpoint = this.apiPath + '/genererIsolee-distri?' + params.toString();
        return this.apiService.get(endpoint, undefined, { responseType: 'blob' });
    }
}
